import { createReducer, on } from '@ngrx/store';
import { ExceptionsState, initialExceptionsState } from './exceptions.state';
import * as ExceptionsActions from './exceptions.actions';

export const exceptionsReducer = createReducer(
  initialExceptionsState,

  on(ExceptionsActions.streamExceptions, (state, { preserveExisting }) => ({
    ...state,
    exceptions: preserveExisting ? state.exceptions : [],
    loading: true,
    started: true,
    error: null,
    loadedServicesCount: 0,
    totalServicesCount: 0,
  })),

  on(ExceptionsActions.streamCancel, ExceptionsActions.streamClear, () => ({
    ...initialExceptionsState,
  })),

  on(ExceptionsActions.startedReset, state => ({
    ...state,
    started: false,
    error: null,
  })),

  on(ExceptionsActions.streamInit, (state, { total_services }) => ({
    ...state,
    totalServicesCount: total_services,
  })),

  on(ExceptionsActions.streamChunk, (state, { exceptions }) => ({
    ...state,
    exceptions: [...state.exceptions, ...exceptions],
    loadedServicesCount: state.loadedServicesCount + 1,
  })),

  on(ExceptionsActions.streamComplete, (state, { total_count, services_failed }) => ({
    ...state,
    loading: false,
    totalCount: total_count,
    servicesFailed: services_failed ?? [],
    streamCompletedAt: new Date().toISOString(),
  })),

  on(ExceptionsActions.streamError, (state, { error }) => ({
    ...state,
    loading: false,
    started: false,
    error,
  })),

  // ── Trace ────────────────────────────────────────────────────────────────

  on(ExceptionsActions.loadTrace, (state, { operationId }) => {
    const { [operationId]: _removed, ...traceErrors } = state.traceErrors;
    return {
      ...state,
      traceLoadingIds: [...state.traceLoadingIds, operationId],
      traceErrors,
    };
  }),

  on(ExceptionsActions.loadTraceSuccess, (state, { operationId, steps }) => ({
    ...state,
    traces: { ...state.traces, [operationId]: steps },
    traceLoadingIds: state.traceLoadingIds.filter(id => id !== operationId),
  })),

  on(ExceptionsActions.loadTraceFailure, (state, { operationId, error }) => ({
    ...state,
    traceLoadingIds: state.traceLoadingIds.filter(id => id !== operationId),
    traceErrors: { ...state.traceErrors, [operationId]: error },
  })),
);
